module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright",
    attrs: {
      "id": "ch00_fm04_copy"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("© 2013 The Johns Hopkins University Press"), _c('br'), _vm._v("All rights reserved. Published 2013"), _c('br'), _vm._v("Printed in the United States of America on acid-free paper"), _c('br'), _vm._v("9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press"), _c('br'), _vm._v("2715 North Charles Street"), _c('br'), _vm._v("Baltimore, Maryland 21218-4363"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.press.jhu.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.jhu.edu")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Turkel, William J. (William Joseph), 1967–")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Spark from the deep : how shocking experiments with strongly electric fish powered scientific")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("discovery / by William J. Turkel.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("    pages cm — (Animals, history, culture)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 978-1-4214-0981-8 (hardcover : alk. paper) — "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 978-1-4214-0994-8 (electronic) —"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 1-4214-0981-X (hardcover : alk. paper) — "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 1-4214-0994-1 (electronic)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("1. Electric fishes. 2. Electricity—Experiments—History. 3. Discoveries in sciences—History.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("QL")]), _vm._v("639.1. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v("87 2013")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("597—dc23 2012038726")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("A catalog record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("Special discounts are available for bulk purchases of this book. For more information, please contact Special Sales at 410-516-6936 or specialsales@press.jhu.edu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Johns Hopkins University Press uses environmentally friendly book materials, including recycled text paper that is composed of at least 30 percent post-consumer waste, whenever possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12612b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_copy.vue
// module id = 69
// module chunks = 0